/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * 十八线_接口文档
 * 十八线——小众旅游
 * OpenAPI spec version: 版本号:0.0.1
 */
import type {
  AjaxResult,
  NotifyLogDetailPathParameters,
  NotifyLogListParams,
  TableDataInfo
} from '../../../types/api';

import { orvalMutator } from '../../../utils/orval-mutator';



  export const get = () => {
/**
 * @summary 查询推送日志详情（含报文全文）
 */
const notifyLogDetail = (
    { logId }: NotifyLogDetailPathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/notify/${logId}`, method: 'GET'
    },
      );
    }
  /**
 * @summary 查询推送日志列表（不含报文全文）
 */
const notifyLogList = (
    params: NotifyLogListParams,
 ) => {
      return orvalMutator<TableDataInfo>(
      {url: `/travel18/reward/notify/list`, method: 'GET',
        params
    },
      );
    }
  return {notifyLogDetail,notifyLogList}};
export type NotifyLogDetailResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['notifyLogDetail']>>>
export type NotifyLogListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['notifyLogList']>>>
